import { Skeleton } from "@/components/ui/skeleton";

/* eslint-disable react/react-in-jsx-scope */
export const DescriptifSkeleton = () => {
  return (
    <>
      <div className="rounded-[20px] bg-[#F7F9FB] p-5 mt-5">
        <Skeleton className="bg-[#ecedee] w-[500px] h-[150px] rounded-[20px]" />
        <div className="grid grid-cols-2 gap-4 px-5 mt-5">
          <div className=" flex flex-col w-full gap-4 ">
            <div>
              <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
              <Skeleton className="bg-[#ecedee] w-full h-12 rounded-sm" />
            </div>
            <div>
              <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
              <Skeleton className="bg-[#ecedee] w-full h-12 rounded-sm" />
            </div>
            <div>
              <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
              <Skeleton className="bg-[#ecedee] w-full h-[100px] rounded-sm" />
            </div>
          </div>
          <div className=" flex flex-col w-full gap-4 ">
            <div className="grid grid-cols-2 gap-4 px-5 ">
              <div>
                <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
                <Skeleton className="  bg-[#ecedee] w-full h-10 rounded-sm" />
              </div>
              <div>
                <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
                <Skeleton className="  bg-[#ecedee] w-full h-10 rounded-sm" />
              </div>
            </div>
            <div>
              <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
              <Skeleton className="  bg-[#ecedee] w-full h-12 rounded-sm" />
            </div>
            <div>
              <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
              <div className="grid grid-cols-2 gap-4 px-5 ">
                <Skeleton className="  bg-[#ecedee] w-full h-12 rounded-sm" />
                <Skeleton className="  bg-[#ecedee] w-full h-12 rounded-sm" />
              </div>
            </div>
            <div>
              <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
              <div className="grid grid-cols-2 gap-4 px-5 ">
                <Skeleton className="  bg-[#ecedee] w-full h-12 rounded-sm" />
                <Skeleton className="  bg-[#ecedee] w-full h-12 rounded-sm" />
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-4 gap-4 px-5 mt-5">
          <div className="ml-10">
            <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
            <Skeleton className="  bg-[#ecedee] w-full h-24 rounded-sm" />
          </div>
          <div className="flex flex-col gap-4">
            <div>
              <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
              <Skeleton className="  bg-[#ecedee] w-full h-12 rounded-sm" />
            </div>
            <div>
              <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
              <Skeleton className="  bg-[#ecedee] w-full h-12 rounded-sm" />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div>
              <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
              <Skeleton className="  bg-[#ecedee] w-full h-12 rounded-sm" />
            </div>
            <div>
              <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
              <Skeleton className="  bg-[#ecedee] w-full h-12 rounded-sm" />
            </div>
          </div>
          <div>
            <div>
              <Skeleton className="bg-[#ecedee] w-1/2 h-5 rounded-sm mb-5" />
              <Skeleton className="  bg-[#ecedee] w-full h-12 rounded-sm" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
